import React from "react";
import PropTypes from "prop-types";

import WithThemeLoading from "../hoc/withThemeLoading";
import Theme1 from "../themes/theme1/theme1";
import Theme2 from "../themes/theme2/theme2";
import Theme3 from "../themes/theme3/theme3";
import Theme4 from "../themes/theme4/theme4";
import Theme5 from "../themes/theme5/theme5";

const Home = (props) => {
  const { template, locale } = props.pageContext;

  /** Begin: Theme Switcher */
  const templateId =
    process.env.GATSBY_TEST_THEME === "0"
      ? template.id
      : process.env.GATSBY_TEST_THEME;

  const themes = [Theme1, Theme2, Theme3, Theme4, Theme5];
  const ThemeLoading =
    parseInt(templateId) > 0
      ? WithThemeLoading(themes[parseInt(templateId) - 1])
      : WithThemeLoading(Theme1);
  /** End: Theme Switcher */
  return <ThemeLoading locale={locale} {...props} />;
};

Home.propTypes = {
  pageContext: PropTypes.object.isRequired,
};

export default Home;
